export const ID_STRUCTURE = 'structureLPlus'
export const ID_STRUCTURE_CONTENT = `${ID_STRUCTURE}Content`
